export const LightState = {
    OFF: "OFF",
    ON: "ON",
};

export const DefaultLightState = LightState.OFF;
